import React, {useEffect, useState} from 'react';
import API from "../../../utils/API";
import {API_ENDPOINTS} from "../../../apiConfig";
import AdminDataView from "../../../components/AdminDataView";
import Forms from "../../../components/Forms";
import EditIconButton from "../../../components/Forms/EditIconButton";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import {useModal} from "../../../contexts/ModalContext";
import PartMasterModal from "../../../components/PartMasterModal";
import PartMasterDuplicateModal from "../../../components/PartMasterDuplicateModal";

const PartMasters = () => {
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState('');
    const {openModal, confirm} = useModal();

    const load = async () => {
        const {data} = await API.get(API_ENDPOINTS.part.list);
        setRows(data || []);
    };

    useEffect(() => {
        load();
    }, []);

    const openEdit = (part) => openModal(PartMasterModal, {part, onSaved: load}, {title: 'Master produkt'});
    const openNew = () => openModal(PartMasterModal, {onSaved: load}, {title: 'Nový master produkt'});
    const askDelete = async (row) => {
        const ok = await confirm(`Smazat master ${row.name}?`);
        if (!ok) return;
        await API.delete(API_ENDPOINTS.part.delete(row._id));
        await load();
    };
    const openDuplicate = (part) => openModal(
        PartMasterDuplicateModal,
        {part, onSaved: load},
        {title: `Duplikovat: ${part.name}`}
    );

    const filtered = (rows || []).filter((row) => {
        const q = filter.toLowerCase();
        return (row.name || '').toLowerCase().includes(q) || (row.code || '').toLowerCase().includes(q);
    });

    const columns = [
        {key: 'name', name: 'Název', renderCell: ({row}) => row.name, minWidth: 260},
        {key: 'code', name: 'Kód', renderCell: ({row}) => row.code, minWidth: 120},
        {key: 'type', name: 'Typ', renderCell: ({row}) => row.type, minWidth: 100},
        {key: 'schema', name: 'Parametry variant', renderCell: ({row}) => (row.variantSchema || []).length, minWidth: 100},
        {key: 'compatible', name: 'Kompatibilita', renderCell: ({row}) => (row.compatibleWith || []).map((d) => d.name).join(', ')},
        {
            key: 'actions',
            name: 'Akce',
            width: 180,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <Forms.Button className="!py-1 !px-2 mr-2" label="Duplikovat" onClick={() => openDuplicate(row)}/>
                    <EditIconButton title="Upravit" onClick={() => openEdit(row)}/>
                    <DeleteIconButton title="Smazat" onClick={() => askDelete(row)}/>
                </div>
            )
        }
    ].map((c) => ({...c, resizable: true}));

    return (
        <div>
            <div className="flex items-end gap-4 mb-4">
                <Forms.Button label="Přidat master produkt" onClick={openNew}/>
                <div className="w-80">
                    <Forms.Text label="Filtr" value={filter} onChange={setFilter}/>
                </div>
            </div>
            <AdminDataView section="part-masters" rows={filtered} columns={columns}/>
        </div>
    );
};

export default PartMasters;
